import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-buy-assistance-package',
  templateUrl: './buy-assistance-package.component.html',
  styleUrls: ['./buy-assistance-package.component.scss']
})
export class BuyAssistancePackageComponent implements OnInit {

  constructor(
    
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) { }

  article: any;
  state: any = 1;
  confirmed: boolean;
  order: any;

  selectState(state){
    this.state = state
  }
  receiveConfirmation($event){
    this.article = $event
    this.selectState(1);
  }

  fwdOrder($event) { 
    this.order = $event; 
    this.selectState(this.state + 1)
  }


  ngOnInit(): void {
    this.article = this.modalData.article
  }

}
